module.exports = __webpack_public_path__ + "img/download.c64406a7.svg";